module.exports = __webpack_public_path__ + "static/roxy-poster-4d23bb9ae5da417f9ff5d1853aa29a9c.jpg";